import { Trans } from "@lingui/react/macro";
import { Editor } from "@tiptap/react";

const MenuBar = ({ editor }: { editor: Editor }) => {
  const className = (active?: boolean) =>
    // eslint-disable-next-line lingui/no-unlocalized-strings
    `bg-white border border-can-silver-cloud px-2 rounded ${
      active
        ? // eslint-disable-next-line lingui/no-unlocalized-strings
          "bg-linear-to-r from-can-tranquil-azure to-can-mystic-aqua border-white"
        : ""
    }`;

  return (
    <div className="border-y-can-sky-blue flex flex-wrap justify-between gap-2 border-y px-2 py-2">
      <button
        className={className(editor.isActive("bold"))}
        onClick={() => editor.chain().focus().toggleBold().run()}
        type="button"
      >
        <b>B</b>
      </button>
      <button
        className={className(editor.isActive("italic"))}
        onClick={() => editor.chain().focus().toggleItalic().run()}
        type="button"
      >
        <i>I</i>
      </button>
      <button
        className={className()}
        onClick={() => editor.chain().focus().unsetAllMarks().run()}
        type="button"
      >
        <Trans>Zrušit formátování</Trans>
      </button>
      <button
        className={className(editor.isActive("heading", { level: 1 }))}
        onClick={() => editor.chain().focus().toggleHeading({ level: 1 }).run()}
        type="button"
      >
        <Trans>Nadpis 1</Trans>
      </button>
      <button
        className={className(editor.isActive("heading", { level: 2 }))}
        onClick={() => editor.chain().focus().toggleHeading({ level: 2 }).run()}
        type="button"
      >
        <Trans>Nadpis 2</Trans>
      </button>
      <button
        className={className(editor.isActive("heading", { level: 3 }))}
        onClick={() => editor.chain().focus().toggleHeading({ level: 3 }).run()}
        type="button"
      >
        <Trans>Nadpis 3</Trans>
      </button>
      <button
        className={className(editor.isActive("heading", { level: 4 }))}
        onClick={() => editor.chain().focus().toggleHeading({ level: 4 }).run()}
        type="button"
      >
        <Trans>Nadpis 4</Trans>
      </button>
      <button
        className={className(editor.isActive("heading", { level: 5 }))}
        onClick={() => editor.chain().focus().toggleHeading({ level: 5 }).run()}
        type="button"
      >
        <Trans>Nadpis 5</Trans>
      </button>
      <button
        className={className(editor.isActive("heading", { level: 6 }))}
        onClick={() => editor.chain().focus().toggleHeading({ level: 6 }).run()}
        type="button"
      >
        <Trans>Nadpis 6</Trans>
      </button>
      <button
        className={className(editor.isActive("bulletList"))}
        onClick={() => editor.chain().focus().toggleBulletList().run()}
        type="button"
      >
        <Trans>Seznam</Trans>
      </button>
      <button
        className={className(editor.isActive("orderedList"))}
        onClick={() => editor.chain().focus().toggleOrderedList().run()}
        type="button"
      >
        <Trans>Číslovaný seznam</Trans>
      </button>
    </div>
  );
};

export { MenuBar };
